import Route from '@ember/routing/route';

export default class TagsRoute extends Route {}
